var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2425 2.22205C13.2923 1.19617 11.9651 0.631226 10.5003 0.631226C9.02762 0.631226 7.69608 1.19275 6.75028 2.21228C5.79422 3.24304 5.3284 4.64392 5.43778 6.15662C5.65458 9.14099 7.92557 11.5687 10.5003 11.5687C13.075 11.5687 15.3421 9.14148 15.5623 6.15759C15.6731 4.65857 15.2044 3.26062 14.2425 2.22205ZM19.094 22.5062H1.90653C1.68156 22.5092 1.45877 22.4619 1.25436 22.3679C1.04996 22.2739 0.869079 22.1355 0.724889 21.9628C0.407506 21.5834 0.279576 21.0653 0.374303 20.5414C0.786412 18.2552 2.07255 16.3348 4.09403 14.9867C5.88993 13.7899 8.16483 13.1312 10.5003 13.1312C12.8357 13.1312 15.1106 13.7904 16.9065 14.9867C18.928 16.3344 20.2141 18.2548 20.6263 20.5409C20.721 21.0648 20.5931 21.5829 20.2757 21.9623C20.1315 22.1351 19.9507 22.2736 19.7463 22.3677C19.5419 22.4618 19.319 22.5091 19.094 22.5062Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilled);
export default __webpack_public_path__ + "static/media/profileFilled.144e21a7b32c429da3b38e6385e92fc9.svg";
export { ForwardRef as ReactComponent };